// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./semantics/animations.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./semantics/font-face.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /* 9fbef606107a605d69c0edbcd8029e5d */

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body {
    font-family: var(--dui-font-family);
  }
`, "",{"version":3,"sources":["webpack://./node_modules/@dhl-official/tokens/dist/css/index.css"],"names":[],"mappings":";EACE,qCAAqC;;EAMrC;;;IAGE,sBAAsB;EACxB;;EAEA;;IAEE,mCAAmC;EACrC","sourcesContent":["\n  /* 9fbef606107a605d69c0edbcd8029e5d */\n\n  @import \"./base.css\";\n  @import \"./semantics/animations.css\";\n  @import \"./semantics/font-face.css\";\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  html,\n  body {\n    font-family: var(--dui-font-family);\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
